module.exports = __webpack_public_path__ + "media/images/pic/lectors/marianna-szumal-345082a20644be34f0c60a1f1f634f2e.jpeg";